import React from 'react';
import { Typography, Row, Col, Card, Space, Avatar } from 'antd';
import { 
    ProjectOutlined, 
    MailOutlined,
    TeamOutlined,
    CompassOutlined,
} from '@ant-design/icons';
import GsrdWch from '../../components/GsrdWch';

const { Title, Paragraph } = Typography;

export default function AboutUs() {
    return (
        <div className="shared-hero-page" style={{ backgroundColor: '#f9fbff', minHeight: '100vh', paddingBottom: '100px' }}>
            {/* Hero Section */}
            <div className="shared-hero-banner" style={{
                padding: '100px 0 140px',
                textAlign: 'center',
                color: 'white',
                marginBottom: '-80px'
            }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                    <Title level={1} style={{ color: 'white', fontSize: '48px', fontWeight: 800, marginBottom: '16px' }}>
                        About Us
                    </Title>
                </div>
            </div>

            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 40px' }}>
                <Space direction="vertical" size={40} style={{ width: '100%' }}>
                    
                    {/* Imputation Server Card
                    <Card bordered={false} style={{ borderRadius: '24px', boxShadow: '0 10px 30px rgba(0,0,0,0.06)' }} bodyStyle={{ padding: '48px' }}>
                        <Title level={2} style={{ fontWeight: 800, color: '#055878', marginBottom: '24px', display: 'flex', alignItems: 'center' }}>
                            <InfoCircleOutlined style={{ marginRight: '16px', color: '#13769a' }} />
                            <GsrdWch /> Imputation Server
                        </Title>
                        <Paragraph style={{ fontSize: '18px', lineHeight: '1.8', color: '#444' }}>
                            The Genome Sequencing of Rare Disease (GSRD)-100K Haplotype Reference Panel aims to improve
                            genomic imputation across diverse Chinese populations. Developed using whole genome sequencing (WGS) data from
                            22,374 subjects with a total of 321,365,014 variants, this panel is part of the broader <GsrdWch /> project.
                        </Paragraph>
                    </Card> */}

                    {/* Project Details Card */}
                    <Card bordered={false} style={{ borderRadius: '24px', boxShadow: '0 10px 30px rgba(0,0,0,0.06)' }} bodyStyle={{ padding: '48px' }}>
                        <Title level={2} style={{ fontWeight: 800, color: '#055878', marginBottom: '32px', display: 'flex', alignItems: 'center' }}>
                            <ProjectOutlined style={{ marginRight: '16px', color: '#13769a' }} />
                            <GsrdWch /> &nbsp;Project
                        </Title>
                        <Paragraph style={{ fontSize: '17px', lineHeight: '1.8', color: '#444' }}>
                            The <GsrdWch /> project aims to collect and analyze phenotype information and whole genome sequencing data from 100,000 rare disease patients and 20,000 healthy individuals. This project seeks to uncover the molecular causes and mechanisms of rare diseases, advancing precision diagnosis and innovative treatment techniques. This extensive effort focuses on improving early diagnosis, which is crucial for disease intervention and birth defect prevention.
                        </Paragraph>
                        <Paragraph style={{ fontSize: '17px', lineHeight: '1.8', color: '#444' }}>
                            Since its initiation in July 2020, the project has conducted comprehensive whole genome sequencing on rare disease cases across various clinical disciplines and undiagnosed hearing loss cases in the CDGC cohort. As of May 2024, it has sequenced 12,791 samples from hearing loss and related syndromes, 11,020 samples from rare disease patients excluding hearing loss, and 11,399 samples from the general population, achieving an average sequencing depth of 47x. The project has amassed over 10 PB of sequencing and initial analysis data and established a biobank capable of storing samples from 400,000 patients and family members.
                        </Paragraph>
                        <Paragraph style={{ fontSize: '17px', lineHeight: '1.8', color: '#444', marginBottom: 0 }}>
                            With a fully automated nucleic acid extraction, library construction, and high-throughput sequencing pipeline, the project has also developed comprehensive information management systems, including a genetic resource management system, phenotype collection platform, and genomic laboratory management system. Additionally, the <GsrdWch /> project is creating an advanced medical genomic data analysis framework and clinical intelligent decision support system to enhance the analysis and interpretation of genetic data. This infrastructure aims to provide powerful support for genetic research and clinical applications, leading to deeper insights into the genetic basis of complex diseases and improved patient care.
                        </Paragraph>
                    </Card>

                    {/* Map Section */}
                    <Card bordered={false} style={{ borderRadius: '24px', boxShadow: '0 10px 30px rgba(0,0,0,0.06)', border: '1px solid #edf4f7', background: '#ffffff' }} bodyStyle={{ padding: '40px 48px 48px' }}>
                        <Title level={2} style={{ fontWeight: 800, color: '#055878', marginBottom: '28px', display: 'flex', alignItems: 'center', lineHeight: 1.25 }}>
                            <CompassOutlined style={{ marginRight: '14px', color: '#13769a', fontSize: '24px' }} />
                            <GsrdWch />&nbsp; Sample Collection across Mainland China
                        </Title>
                        <div style={{ background: 'linear-gradient(180deg, #f8fcfd 0%, #ffffff 100%)', borderRadius: '18px', padding: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #dfecef', boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.85)' }}>
                            {/* 样本采集地图改为静态图片，避免地图组件加载和比例显示问题 */}
                            <img
                                src="https://gsrd-server.tos-cn-beijing.volces.com/Sample_Collection.png"
                                alt="GSRD-100K WCH Sample Collection across Mainland China"
                                style={{ width: '100%', maxWidth: '1040px', height: 'auto', display: 'block', borderRadius: '10px' }}
                            />
                        </div>
                    </Card>

                    {/* Contact Section */}
                    <Card bordered={false} style={{ borderRadius: '24px', boxShadow: '0 10px 30px rgba(0,0,0,0.06)', border: '1px solid #e5f0f4', background: 'linear-gradient(180deg, #ffffff 0%, #f8fcfd 100%)' }} bodyStyle={{ padding: '48px' }}>
                        <Title level={2} style={{ fontWeight: 800, color: '#055878', marginBottom: '28px', display: 'flex', alignItems: 'center' }}>
                            <TeamOutlined style={{ marginRight: '16px', color: '#13769a' }} />
                            CONTACT US
                        </Title>

                        <Row gutter={[18, 18]}>
                            {[
                                { name: 'Prof. Yuan, Huijun', email: 'yuanhuijun@wchscu.edu.cn' },
                                { name: 'Prof. Cheng, Jing', email: 'chengjing@wchscu.cn' },
                                { name: 'Prof. Lu, Yu', email: 'luyu@wchscu.cn' },
                                { name: 'Prof. Bu, Fengxiao', email: 'bufengxiao@wchscu.cn' },
                            ].map((contact) => (
                                <Col xs={24} sm={12} lg={6} key={contact.email}>
                                    {/* 联系人取消分类小标题，统一作为同层级联系卡片展示 */}
                                    <Card
                                        bordered={false}
                                        style={{
                                            height: '100%',
                                            borderRadius: '18px',
                                            border: '1px solid #dcecf1',
                                            background: '#ffffff',
                                            boxShadow: '0 12px 26px rgba(7, 82, 104, 0.08)',
                                        }}
                                        bodyStyle={{ padding: '24px 20px' }}
                                    >
                                        <Space direction="vertical" align="center" size={14} style={{ width: '100%', textAlign: 'center' }}>
                                            <Avatar
                                                size={56}
                                                icon={<MailOutlined />}
                                                style={{
                                                    background: 'linear-gradient(135deg, #0e7184 0%, #138fa0 100%)',
                                                    boxShadow: '0 8px 18px rgba(12, 105, 124, 0.22)',
                                                }}
                                            />
                                            <div>
                                                <div style={{ fontWeight: 750, fontSize: '17px', color: '#123243', lineHeight: 1.35 }}>
                                                    {contact.name}
                                                </div>
                                                <a
                                                    href={`mailto:${contact.email}`}
                                                    style={{
                                                        display: 'inline-block',
                                                        marginTop: '8px',
                                                        color: '#0b6f83',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        wordBreak: 'break-all',
                                                    }}
                                                >
                                                    {contact.email}
                                                </a>
                                            </div>
                                        </Space>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Card>

                    <div style={{ height: '60px' }} />
                </Space>
            </div>
        </div>
    );
}
